import { RRIBaseTableActionSettings } from './base-table-action-settings.interface';

export interface RRITableAddActionSettings<T>
  extends RRIBaseTableActionSettings {
  addButtonText?: string;
  formatNavigateToUrl?: (row: T) => string;
}
